import type {
  SpeechService,
  SpeechSession,
  TranscribeOptions,
  TranscriptChunk,
} from '../../ports/speech'
import { delay } from './util'

const WORDS = ['Fasse', 'den', 'markierten', 'Abschnitt', 'in', 'drei', 'Sätzen', 'zusammen.']

export class MockSpeechService implements SpeechService {
  async start(opts?: TranscribeOptions): Promise<SpeechSession> {
    let stopped = false
    const signal = opts?.signal

    async function* generate(): AsyncIterable<TranscriptChunk> {
      let acc = ''
      for (const word of WORDS) {
        if (stopped || signal?.aborted) break
        await delay(300)
        acc += (acc ? ' ' : '') + word
        yield { text: acc, isFinal: false }
      }
      yield { text: acc, isFinal: true }
    }

    return {
      transcripts: generate(),
      async stop() {
        stopped = true
      },
    }
  }
}
